






import { Component, Vue, Prop } from "vue-property-decorator"

@Component
export default class Toast extends Vue {
  @Prop(String) private toastMsg?: string
  @Prop(Number) private toastTime?: number

  msg: string = ""

  created() {
    this.msg = this.toastMsg || ""
    setTimeout(() => {
      this.msg = ""
    }, this.toastTime || 2000)
  }
}
